import React, { useContext, useEffect, useState } from "react";
import { SimpleDialogComponent } from "../../../general_components/SimpleDialogComponent";
import SearchIcon from "@mui/icons-material/Search";
import { SearchFormGeneral } from "./SearchFormGeneral";
import { Grid, MenuItem } from "@mui/material";
import Button from "@mui/material/Button";
import { CajasContext } from "src/context/CajasContext/CajasContext";
import { getContenidosSearchPaginatedSoloContenidos, getAllDataForExport, getExportXlsxCount } from "../helpers/ContenidosData";
import { SnackbarMessenger } from "../../../general_components/SnackbarMessenger";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import Divider from "@mui/material/Divider";
import { TheLayoutContext } from "src/context/TheLayoutContext";
import { SwitchAjuste } from "./SwitchAjuste";
import {
  movementContenidos,
} from "../helpers/ContenidosData";
import { SelectRetiroPrioridad } from "./SelectRetiroPrioridad";
import { ContenidosFormProcesosVarios } from "./ContenidosFormProcesosVarios";
import { colorMarcadoContenidos, estadoColoresContenidos, estadoIconosContenidos, iconosMarcadoContenidosList } from "./estadosCajas";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AWS from 'aws-sdk';
import { configS3 } from "src/configs/config";
import { Typography } from "@mui/material";
import { getContenidosSearchHistorico } from "../helpers/HistoricoCajasData";
import { MovimientosTimelineMUIContenidos } from "./MovimientosTimelineMUIContenidos";
import esArray from "src/general_components/functionEsArray";
import Popover from '@mui/material/Popover';
import HistoryIcon from "@mui/icons-material/History";
import { GridActionsCellItem } from "@mui/x-data-grid";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ModalImpresionEtiquetasComprobantes } from "./ModalImpresionEtiquetasComprobantes";
import { comprobantesPrintData } from "../helpers/ComprobantesData";
import ContenidosMetadatosCell from "./TablaMetadatosContenidos";

export const ContenidosProcesoList = (datos) => {

  const {
    retiro_contenido_parcial,
    retiro_contenido_total,
    quita_total_contenidos,
    devolucion_contenidos_parcial,
    procesoSeleccionado,
    devolucion_contenidos_total,
    tituloProceso,
    consulta_general,
    changeProceso,
    owner
  } = datos.datos;

  const {
    dataSearchFormGeneral, snackbarVisible, message, severity, setOmitirQuerySearch, setAProcesar,
    setListRecords, setSnackbarVisible, setResponseSearchFormGeneral, setSoloCajas, limpiarSearchForm,
    actualizarListado, setActualizarListado, setSelectionModel,
    tipoRetiroSeleccionado, selectionModel, setSectorId, setTipoRetiroSeleccionado, setTipoContenidoSeleccionado,
    disabled, setListDatosEstadosCajas, setDisabled, setMessage, setSeverity,
    setRequiredFormEstadosCajas, setActualizarListadoContenidos, setBusquedaSearchOn, setTipoRetiroMovimientoSeleccionado,
    tipoRetiroMovimientoSeleccionado, setDataSearchFormGeneral, desmarcar, setShowFormUbicaciones, setShowFormEstadosCajas, setShowFormFechaAltaCajas, setShowFormMovimientos,
    setRequiredFormCuentaSector, setListDatosFormIdCajas, setDataSearchFormEstadosCajas,
    setListDatosFechaAltaCajas, setListDatosFormCuentaSector, setClienteIdSearch,
  } = useContext(CajasContext);

  const user_data = JSON.parse(localStorage.getItem("siam-user-data"));
  const id_perfil_usuario = user_data?.id_perfiles;

  const [abrirBusqueda, setAbrirBusqueda] = useState(false);
  const [pushData, setPushData] = useState(false);
  const { setChildFooter, setExpand, subProcesoLocal, clienteIdLocal, s3Json, subProceso, setS3Json, setClienteId, clienteId } = useContext(TheLayoutContext);
  const [ajuste, setAjuste] = useState(false);
  const [abrirDetalle, setAbrirDetalle] = useState(false);

  const [modalStateHistorico, setMOdalStateHistorico] = useState(false);
  const [historicoCaja, setHistoricoCaja] = useState(false);
  const [params, setParams] = useState(false);
  const [open, setOpen] = useState(null); // variable popover

  const [modalStateImpresionEtiquetasComprobantes, setModalStateImpresionEtiquetasComprobantes] = useState(false);
  const [responseProcesar, setResponseProcesar] = useState(false);
  const mensajeImpresionEtiquetasComprobantes = `El proceso ${tituloProceso} se ha ejecutado correctamente`;

  /* Se arma la columna "Acciones que va a tener editar y borrar " */
  const actionColumn = {
    field: "actions",
    headerName: "Acciones",
    type: "actions",
    flex: 0.5,
    width: 100,
    minWidth: 100,
    maxWidth: 125,
    getActions: (params) => [
      <GridActionsCellItem
        icon={
          <Tooltip title="Acciones">
            <span>
              <MoreVertIcon color="info" />
            </span>
          </Tooltip>
        }
        onClick={(e) => {
          handleOpenMenu(e);
          setParams(params)
        }}
        label="Acciones"
      />
    ],
  };



  const toggleModal = () => {
    setAbrirBusqueda(!abrirBusqueda);
  };

  /// Ejecuta las funciones que consumen el servicio search y cierra el modal de busqueda
  const ObtenerDatos = () => {
    setAbrirBusqueda(!abrirBusqueda);
  };


  //Se asignan valores a localstorage para utilizarlos en renderIconBasedOnId ya que no los toma si no se hace de esta forma
  localStorage.setItem("siam-procesoSeleccionado", JSON.stringify(procesoSeleccionado));
  localStorage.setItem("siam-subProcesoSeleccionado", JSON.stringify(subProceso));

  const renderIconBasedOnId = (idrow) => {
    // Obtener el ID del usuario actual desde el almacenamiento local
    const userId = JSON.parse(localStorage.getItem("siam-user-data")).id;

    // Obtener los datos del almacenamiento local y parsearlos si existen
    const localStorageData = localStorage.getItem("siam-datos3");
    let data = localStorageData ? JSON.parse(localStorageData) : undefined;

    // Objeto para almacenar los IDs por proceso
    const idsPorProceso = {};

    // Verificar si existen datos en el almacenamiento local
    if (data) {
      // Iterar sobre los procesos y usuarios en los datos
      for (const proceso in data) {
        for (const usuario in data[proceso]) {
          // Verificar si el usuario actual es el usuario deseado (userId)
          if (usuario === userId) {
            // Inicializar el array de IDs para el proceso actual si aún no existe
            if (!idsPorProceso[proceso]) {
              idsPorProceso[proceso] = [];
            }

            // Iterar sobre los subprocesos y clientes en los datos
            for (const subProcesos in data[proceso][usuario]) {
              for (const cliente in data[proceso][usuario][subProcesos]) {
                // Obtener los IDs y agregarlos al array de IDs para el proceso actual
                const ids = data[proceso][usuario][subProcesos][cliente].id;
                if (ids && Array.isArray(ids)) {
                  idsPorProceso[proceso] = [...idsPorProceso[proceso], ...(ids[0] || [])];
                }
              }
            }
          }
        }
      }

      // Mapeo de procesos a colores
      const procesoColorMapping = {
        devolucion_caja: 'devolucion_caja',
        devolucion_cajas: 'devolucion_cajas',
        retiro_cajas: 'retiro_cajas',
        retiro_contenidos: 'retiro_contenidos',
        mudanza_cajas: 'mudanza_cajas',
        ubicacion_cajas: 'ubicacion_cajas',
        devolucion_contenidos: 'devolucion_contenidos',
        ubicacion_temporal: 'ubicacion_temporal',
        retiro_definitivo: 'retiro_definitivo',
        baja_expurgue: 'baja_expurgue',
        retiro_contenido_parcial: 'retiro_contenido_parcial',
        retiro_contenido_total: 'retiro_contenido_total',
        quita_total_contenidos: 'quita_total_contenidos',
        devolucion_contenidos_parcial: 'devolucion_contenidos_parcial',
        devolucion_contenidos_total: 'devolucion_contenidos_total',
      };

      // Obtener el color seleccionado
      let selectedColor = obtenerColoresPorProceso(idsPorProceso, idrow, procesoColorMapping);
      return selectedColor;
    }

    // Retornar null si no hay datos en el almacenamiento local
    return null;
  };

  const convertirTexto = (texto) => {
    // Dividir el texto en palabras usando el guion bajo como delimitador
    const palabras = texto.split('_');
    // Convertir la primera letra de cada palabra a mayúscula
    const palabrasMayusculas = palabras.map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1));
    // Unir las palabras con espacios
    const textoConvertido = palabrasMayusculas.join(' ');
    return textoConvertido;
  }

  const obtenerColoresPorProceso = (idsPorProceso, idrow, procesoColorMapping) => {
    const colores = [];
    for (const proceso in idsPorProceso) {
      if (idsPorProceso.hasOwnProperty(proceso)) {
        const procesoIds = idsPorProceso[proceso];
        if (procesoIds && procesoIds.some(ids => ids && ids.includes && ids.includes(idrow.toString()))) {
          const selectedColor = procesoColorMapping[proceso];
          const title = convertirTexto(proceso);
          colores.push({ title, color: selectedColor, proceso: proceso });
        }
      }
    }
    return colores;
  }




  let details = navigator.userAgent;
  let regexp = /android|iphone|kindle|ipad/i;

  let isMobileDevice = regexp.test(details);

  const listName = false;
  let proceso = "InformeGeneralCajas";
  const columns = [
    {
      field: "id_caja",
      headerName: "Caja",
      headerAlign: "left",
      flex: 0.5,
      renderCell: (params) => {
        const procesosYColores = renderIconBasedOnId(params.id); // Icono predeterminado si el estado no tiene un icono definido
        // console.log(params, 'params')
        if (params.value) {
          return (
            <Grid container alignItems="center">
              {procesosYColores && procesosYColores.map((item, index) => {
                const color = colorMarcadoContenidos[item.proceso] || "defaultColor"; // Color predeterminado si el estado no tiene un color definido
                const Icono = iconosMarcadoContenidosList[item.proceso] || null; // Obtiene el icono dinámicamente
                return (
                  <Tooltip key={index} title={`Marcada en ${item.title}`}>
                    <span>
                      {Icono && (
                        <Icono size="small" style={{ color: color, fontSize: 20 }} />
                      )}
                    </span>
                  </Tooltip>
                );
              })}
              <Typography variant="body1" style={{ fontSize: 13, fontFamily: 'Roboto, sans-serif', color: 'black' }}>
                {params.value}
              </Typography>
            </Grid>
          );
        } else {
          return null;
        }
      },
    },
    {
      field: "lote",
      headerName: "Lote",
      headerAlign: "left",
      flex: 0.3,
    },
    {
      field: "sector",
      headerName: "Sector",
      headerAlign: "left",
      flex: 0.5,
    },
    {
      field: "estado_contenido",
      headerName: "Estado",
      headerAlign: "left",
      flex: 0.5,
      renderCell: (params) => {
        if (params.value) {
          const color = estadoColoresContenidos[params.value] || "defaultColor"; // Color predeterminado si el estado no tiene un color definido
          const icono = estadoIconosContenidos[params.value] || <ErrorOutlineIcon />; // Icono predeterminado si el estado no tiene un icono definido
          return (
            <Grid sx={{}}>

              <Tooltip title={params.value}>
                <IconButton style={{ color: color }}>
                  {icono}
                </IconButton>

              </Tooltip>
            </Grid>
          );
        } else {
          return null;
        }
      },
    },
    {
      field: "ubicacion",
      headerName: "Ubicacion",
      headerAlign: "left",
      flex: 1,
    },
    {
      field: "id_contenidos",
      headerName: "Contenidos",
      flex: 4,
      headerAlign: "center",
      renderCell: (params) => <ContenidosMetadatosCell row={params.row} idsContenidos={""} />
    },
  ];

  // ── Bridge con el Asistente IA ──────────────────────────────────────────────
  useEffect(() => {
    const handleAIAction = (e) => {
      const { type, params: p } = e.detail || {};

      if (type === "search_contenidos") {
        const searchParams = {};
        const cajasParams = { fisica: "1" };
        if (p?.id_cajas)   { cajasParams.id_cajas = String(p.id_cajas); cajasParams.idCajasRango = String(p.id_cajas); }
        if (p?.referencia) cajasParams.referencia = String(p.referencia);
        searchParams.cajas = cajasParams;

        setListDatosFormIdCajas({
          id_cajas:            p?.id_cajas   ? String(p.id_cajas)   : "",
          idCajasRango:        p?.id_cajas   ? String(p.id_cajas)   : "",
          referencia:          p?.referencia ? String(p.referencia) : "",
          id_cajas_desde:      "",
          id_cajas_hasta:      "",
          tiposCajasSeleccionadas: [],
          referenciasRango:    "",
          ordenamiento:        "",
          excedida:            "2",
          deformada:           "2",
        });

        if (p?.estados?.length) {
          const estadosArr = p.estados.map((e) => ({ id: String(e.id), detalle: e.detalle }));
          setListDatosEstadosCajas(estadosArr);
          const estadosPayload = {};
          estadosArr.forEach((e) => { estadosPayload[e.id] = e.detalle; });
          setDataSearchFormEstadosCajas(estadosPayload);
          searchParams.estados_cajas = estadosPayload;
        } else {
          setListDatosEstadosCajas([]);
          setDataSearchFormEstadosCajas([]);
        }

        if (p?.fecha_desde || p?.fecha_hasta) {
          const fechas = { fecha_desde: p.fecha_desde || "", fecha_hasta: p.fecha_hasta || "" };
          setListDatosFechaAltaCajas(fechas);
          searchParams.fecha_creacion_cajas = fechas;
        } else {
          setListDatosFechaAltaCajas([]);
        }

        if (p?.id_cuenta) {
          searchParams.cuentas_localizaciones = { id_cuentas: String(p.id_cuenta) };
          setListDatosFormCuentaSector({ cuenta: String(p.id_cuenta) });
          setClienteIdSearch({ id_cuentas: String(p.id_cuenta), razon_social: p.razon_social || "" });
        } else {
          setListDatosFormCuentaSector({});
        }

        setDataSearchFormGeneral({
          coincidencias: "1",
          eliminados: "0",
          search_params: searchParams,
        });
        setBusquedaSearchOn(true);
        setActualizarListado(true);
      }

      if (type === "open_search") {
        setAbrirBusqueda(true);
      }
    };

    window.addEventListener("ai:action", handleAIAction);
    return () => window.removeEventListener("ai:action", handleAIAction);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ───────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    if (changeProceso) {
      limpiarSearchForm();
      setOptions({
        ...options,
        selectCheckbox: procesoSeleccionado?.id === 1 || procesoSeleccionado === null ? false : true,
        valuesSelected: procesoSeleccionado?.id === 1 || procesoSeleccionado === null ? false : setSelectionModel,
        sinFilas: true,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [procesoSeleccionado]);

  const handleDesmarcar = () => {
    // Lógica para desmarcar las cajas si el switch está activo
    if (desmarcar) {
      desmarcarChecks()
    }
  };


  const obtenerProceso = () => {
    let proceso = '';

    if (procesoSeleccionado.label !== 'Consulta General') {
      const palabra = procesoSeleccionado.label.split(/[ /]/);
      // Usamos una expresión regular para dividir por espacio o barra
      const filtro = palabra.filter(word => word.toLowerCase() !== 'de');
      proceso = filtro.join('_').toLowerCase();
    } else {
      let url = window.location.href;
      const arrUrl = url.split("/");
      proceso = arrUrl[arrUrl.length - 1];
      if (proceso.includes("?")) {

        const arrUrl = url.split("?");
        proceso = arrUrl[arrUrl.length - 1];

        const arrUrls = proceso.split("=");
        proceso = arrUrls[arrUrls.length - 2];

      } else {
        proceso = proceso === 'proceso' ? 'ubicacion_cajas' : proceso
      }
    }
    return proceso
  }

  console.log("clienteIdEn local", clienteId);


  const desmarcarChecks = async () => {
    let marcasAWS = { procesos: s3Json }

    let procesoActual = obtenerProceso();
    let id_user = JSON.parse(localStorage.getItem("siam-user-data")).id;


    if (procesoActual === 'devolucion') {
      //   tipo_id = 'id_contenidos'
      procesoActual = 'devolucion_contenidos'
    } else if (procesoActual === 'retiro') {
      //  tipo_id = 'id_contenidos'
      procesoActual = 'retiro_contenidos'
    }

    if (!marcasAWS) {
      marcasAWS = {}
    }

    // const cantidades = Object.keys(marcasAWS.procesos[procesoActual]?.[id_user]?.[subProcesoLocal]).reduce((total, key) => {
    //   return total + Object.keys(marcasAWS.procesos[procesoActual]?.[id_user]?.[subProcesoLocal][key]).length;
    // }, 0);

    const cantidades = Object.keys(marcasAWS.procesos[procesoActual]?.[id_user]?.[subProcesoLocal] ?? {}).reduce((total, key) => {
      const nestedObject = marcasAWS.procesos[procesoActual]?.[id_user]?.[subProcesoLocal]?.[key];

      if (nestedObject && typeof nestedObject === 'object') {
        total += Object.keys(nestedObject).length;
      }

      return total;
    }, 0);

    if (cantidades > 1) {
      delete marcasAWS.procesos[procesoActual]?.[id_user]?.[subProcesoLocal]?.[clienteIdLocal.id_cuentas];
    } else {
      delete marcasAWS.procesos[procesoActual]?.[id_user]?.[subProcesoLocal];
    }

    AWS.config.update(configS3);
    const s3 = new AWS.S3();

    const jsonString = JSON.stringify(marcasAWS, null, 2);
    const file = new Blob([jsonString], { type: 'application/json' });

    const bucketName = configS3.bucketName;
    const ownerCode = JSON.parse(localStorage.getItem("clientData")).owner_code.toLowerCase();
    const key = ownerCode + '-marks.json';

    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
      ContentType: 'application/json',
    };

    try {
      await s3.upload(params).promise();
      localStorage.setItem("siam-datos3", JSON.stringify(marcasAWS.procesos));
      setS3Json(marcasAWS.procesos)
    } catch (error) {
      console.log("¡Error el proceso de Desmarcado no fue realizado con éxito!");
    }


  };


  /// Despliega el buscador cuando se presiona F2
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'F2') {
        setOmitirQuerySearch(true);
        setActualizarListado(true);
        setAbrirBusqueda(!abrirBusqueda);
        setRequiredFormCuentaSector(true);
        setRequiredFormEstadosCajas(true);
        setListDatosEstadosCajas([
          { id: "6", detalle: "Alojada" },
          { id: "7", detalle: "Alojada Temporalmente" },
          { id: "11", detalle: "Alojada - Esperando devolución" },
        ]);
        setSoloCajas(true);
      }
    };

    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
    // eslint-disable-next-line
  }, []);

  const recargarPaginaProcesados = (registrosProcesados) => {

    const arrayIndexado = registrosProcesados.map(item => item.id);
    // const cadenaFormateada = registrosProcesados.join(',');
    const cadenaFormateada = arrayIndexado.join(',');

    const data = {
      coincidencias: '1',
      eliminados: '0',
      search_params: {
        cajas: {
          fisica: '1',
        },
        id_contenidos: cadenaFormateada,

      },
      soloCajas: '0',
      jerarquia: "0",
      limit: "50",
      offset: "0",
      devuelveContenidos: "1",
      exportarCajasContenidos: "0",
      busqueda_digitalizaciones: "0",
    };
    setDataSearchFormGeneral(data);
    setBusquedaSearchOn(true);
  }

  const procesar = async (detalle, contactoId, direccionId, nodoExtra) => {
    setSnackbarVisible(false);

    let registrosFormateados = selectionModel.map((data) => {
      return { id: data };
    });

    let ret_total = retiro_contenido_total;
    let ret_partial = retiro_contenido_parcial;
    let dev_partial = devolucion_contenidos_parcial;
    let dev_total = devolucion_contenidos_total;
    let quita_total = quita_total_contenidos;
    let ret_preferencial = "0";
    let ret_urgente = "0";

    //Paranetros de prioridad
    if (ret_total === "1" || ret_partial === "1") {
      switch (tipoRetiroMovimientoSeleccionado) {
        case "1":
          break;
        case "2":
          ret_preferencial = "1";
          break;
        case "3":
          ret_urgente = "1";
          break;
        default:
          console.log("NO hay coincidencia");
      }
    }



    let valueAjuste = ajuste ? "1" : "0";
    let data = {
      detalle: detalle,
      ret_partial: ret_partial,
      ret_total: ret_total,
      dev_total: dev_total,
      ret_preferencial: ret_preferencial,
      ret_urgente: ret_urgente,
      dev_partial: dev_partial,
      quita_total: quita_total,
      contenidos: registrosFormateados,
      ajuste: valueAjuste,
      contacto: contactoId,
      direccion: direccionId,

    };

    if (nodoExtra) {
      // Agrega las propiedades adicionales a la estructura propiedades
      data.comprobantes_extra_data = nodoExtra.comprobantes_extra_data;
    }

    // var responseMovement = false
    let responseMovement = await movementContenidos(data);

    setAbrirDetalle(!abrirDetalle);
    if (responseMovement.status === "true") {
      recargarPaginaProcesados(registrosFormateados)
      setSnackbarVisible(true);
      setSeverity("success");
      setMessage(responseMovement.message);
      limpiar();
      setResponseProcesar(responseMovement);
      toggleModalImpresionEtiquetaComprobante();
      handleDesmarcar()
      // limpiarSearchForm();
      setDisabled(!disabled);
      setActualizarListado(true);
      setBusquedaSearchOn(true);
      setActualizarListadoContenidos(true);
    } else {
      setAProcesar(null);
      setSnackbarVisible(true);
      setSeverity("warning");
      setMessage(responseMovement.message);

    }
  };

  const limpiar = async () => {
    setSectorId([]);
    setClienteId([]);
    setTipoContenidoSeleccionado("");
    setTipoRetiroSeleccionado("");
    setChildFooter(null);
    setExpand(false);
    setSelectionModel([]);
    setActualizarListado(true);
  };

  const buttonBuscar = (params) => (
    <Button
      endIcon={<SearchIcon />}
      onClick={() => {
        // setAbrirBusqueda(!abrirBusqueda);
        // setActualizarListado(true);
        // setOmitirQuerySearch(true);
        // setSoloCajas(true);

        if (params?.procesoSeleccionado?.id !== 1) {
          console.log("params", params);
          if ((params?.subProceso && params?.subProceso !== 0)) {
            if (id_perfil_usuario === '9') {
              setRequiredFormCuentaSector(true);
              setShowFormUbicaciones(false);
              setShowFormEstadosCajas(false);
              setShowFormFechaAltaCajas(false);
              setShowFormMovimientos(false);
            }
            setAbrirBusqueda(!abrirBusqueda);
            setOmitirQuerySearch(true);
            setSoloCajas(true);
          } else {
            setMessage("Debe seleccionar un subproceso para poder continuar");
            setSeverity("warning");
            setSnackbarVisible(true);
          }
        } else {
          if (id_perfil_usuario === '9') {
            setRequiredFormCuentaSector(true);
            setShowFormUbicaciones(false);
            setShowFormEstadosCajas(false);
            setShowFormFechaAltaCajas(false);
            setShowFormMovimientos(false);
          }
          setAbrirBusqueda(!abrirBusqueda);
          setOmitirQuerySearch(true);
          setSoloCajas(false);
        }
      }}
      variant="contained"
      style={{
        color: '#FFFFFF',
        fontFamily: 'Roboto, sans-serif',
        minWidth: '120px',
        width: '120px',
        fontSize: '11px',
        height: '30px',
      }}
    >
      Buscar
    </Button>
  );


  const [options, setOptions] = useState({
    cols: columns,
    getPaginated: getContenidosSearchPaginatedSoloContenidos,
    setListRecords: setListRecords,
    pageSize: [5, 10, 25],
    listName,
    limit: 50,
    filter: true,
    exportData: true,
    server: false,
    sinFilas: true,
    idElementData: dataSearchFormGeneral,
    hierarchyOn: false,
    detailsOn: false,
    abmContenidos: "false",
    checkboxContenidos: "false",
    setResponseService: setResponseSearchFormGeneral,
    soloContenidosSearch: true,
    exportarCajasContenidos: true,
    getAllData: getAllDataForExport,
    getExportCount: getExportXlsxCount,
    notas: false,
    totales: true,
    buttonExtraOn: true,
    ButtonExtra: buttonBuscar,
    ButtonExtraMarcar: true,
    ButtonExtraDesmarcar: true,
    marcadoYdesmarcado: true,
    autoHeightDatagrid: "false",
    actionColumnCustom: actionColumn,
    edit: true,
  });

  useEffect(() => {
    if (!Array.isArray(dataSearchFormGeneral) && actualizarListado) {
      setOptions({
        ...options,
        idElementData: dataSearchFormGeneral,
        sinFilas: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearchFormGeneral, actualizarListado]);

  if (pushData) {
    if (abrirBusqueda) {
      //CIERRO EL DIALOGO DE BUSQUEDA
      setAbrirBusqueda(!abrirBusqueda);
      //SETEO EL ESTADO PARA QUE SE ACTUALICE EL LISTADO
      setActualizarListado(true);
    }
    setPushData(!pushData);
  }

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'F2') {
        setAbrirBusqueda(!abrirBusqueda);
        setActualizarListado(true);
        setOmitirQuerySearch(true);
        setSoloCajas(true);
      }
    };

    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleModalMovimientos = async () => {
    setMOdalStateHistorico(!modalStateHistorico);

  };

  const toggleModalHistorico = async (id) => {
    const response = await getContenidosSearchHistorico(id, "contenido")

    if (response) {
      setHistoricoCaja(esArray(response.wsResponse.movimientos?.historico));
      toggleModalMovimientos();
    } else {

    }

  };

  const handleHistoricoButton = () => {
    console.log("params", params);
    toggleModalHistorico(params.id);
    handleCloseMenu()
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };


  useEffect(() => {
    if (selectionModel.length > 0) {
      setExpand(true);
      setChildFooter(
        <Grid container spacing={0} alignItems="center" justifyContent="flex-end" style={{ display: 'flex' }}>
          <Grid item xs={!isMobileDevice ? 3 : 6} style={{ marginLeft: isMobileDevice ? 'auto' : 0, marginRight: isMobileDevice ? 'auto' : 0 }}>
            <SwitchAjuste
              setAjuste={setearAjuste}
              disabledCheckAjuste={selectionModel.length > 0 ? false : true}
            />
          </Grid>
          {(retiro_contenido_parcial === "1" || retiro_contenido_total === "1" || quita_total_contenidos === "1") && (
            <Grid item xs={!isMobileDevice ? 3 : 6} style={{ marginLeft: isMobileDevice ? 'auto' : 0, marginRight: isMobileDevice ? 'auto' : 0 }}>

              <SelectRetiroPrioridad
                disabledSelector={
                  !ajuste &&
                    (retiro_contenido_parcial === "1" ||
                      retiro_contenido_total === "1")
                    ? false
                    : true
                }
                setTipoRetiroMovimientoSeleccionado={
                  setTipoRetiroMovimientoSeleccionado
                }
                tipoRetiroMovimientoSeleccionado={
                  tipoRetiroMovimientoSeleccionado
                }
              />
            </Grid>
          )}


          <Grid item xs={!isMobileDevice ? 3 : 6} style={{ marginLeft: isMobileDevice ? 'auto' : 0, marginRight: isMobileDevice ? 'auto' : 0 }}>
            <Button
              disabled={
                selectionModel.length > 0 && consulta_general !== "1"
                  ? false
                  : true
              }
              variant="contained"
              onClick={() => {
                setAbrirDetalle(!abrirDetalle);
              }}
              style={{
                width: "98%",
                bottom: "6px",
              }}
            >
              Procesar
            </Button>
          </Grid>

        </Grid>
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectionModel,
    tipoRetiroSeleccionado,
    ajuste,
    tipoRetiroMovimientoSeleccionado,
  ]);

  const setearAjuste = async (data) => {
    setAjuste(data);
  };

  const toggleModalProcesar = async () => {
    setAbrirDetalle(!abrirDetalle);
  };

  //Funcion que abre y cierra el modal del formulario de contenidos
  const toggleModalImpresionEtiquetaComprobante = async () => {
    if (!modalStateImpresionEtiquetasComprobantes) {
      setActualizarListado(false);
    } else {
      setActualizarListado(true);
      const contenidos = responseProcesar?.wsResponse?.id_contenidos || []
      let registrosFormateados = esArray(contenidos).map((data) => {
        return { id: data };
      });
      recargarPaginaProcesados(registrosFormateados);
    }
    setModalStateImpresionEtiquetasComprobantes(!modalStateImpresionEtiquetasComprobantes);

  };

  console.log("responseProcesar", responseProcesar);

  const cleanDomain = (domain) =>
    typeof domain === "string" ? domain.replace(/\/+$/, "") : "";


  const handleConfirmImpresionComprobantes = async () => {
    const id_comprobante = responseProcesar?.wsResponse?.id_comprobantes || false;
    const credentials = JSON.parse(localStorage.getItem("clientData"));

    if (!credentials) {
      console.error("No se encontraron credenciales en localStorage");
      return;
    }

    const { dominio, owner_code } = credentials;


    if (!id_comprobante) {
      console.error("No se encontró el ID del comprobante");
      return;
    }
    let dominioLimpio = cleanDomain(dominio);
    const url = `${dominioLimpio}/comprobantes/getComprobanteView/${id_comprobante}?owner_code=${owner_code}`;
    console.log("Abriendo comprobante:", url);

    // 🔹 Abre el PDF en una nueva pestaña
    window.open(url, "_blank");

    // if (id_comprobante) {
    //   try {
    //     // Obtén el contenido HTML
    //     const contenidoChild = await obtenerComprobanteAimprimir(id_comprobante);
    //     // Abre una nueva pestaña con el contenido HTML
    //     const nuevaVentana = window.open();
    //     nuevaVentana.document.write(contenidoChild);
    //   } catch (error) {
    //     console.error("Error al obtener el contenido HTML:", error);
    //     // Maneja el error según sea necesario
    //   }
    // }
  };

  // const obtenerComprobanteAimprimir = async (idComprobante) => {
  //   let paramsPrint = {
  //     id_comprobantes: idComprobante
  //   }
  //   let response = await comprobantesPrintData(paramsPrint)
  //   return response;
  // };

  return (
    <>

      {modalStateHistorico && (
        <SimpleDialogComponent
          open={modalStateHistorico}
          modalName={"Historico"}
          child={<MovimientosTimelineMUIContenidos data={historicoCaja} />}
          setPushData={toggleModalMovimientos}
          handleClose={toggleModalMovimientos}
          buttonEnviar={false}
          buttonCancelar={true}
        />
      )}
      {abrirBusqueda && (
        <SimpleDialogComponent
          open={abrirBusqueda}
          modalName={"Busqueda de contenidos"}
          child={
            <SearchFormGeneral toggleModal={toggleModal} proceso={proceso} />
          }
          setPushData={ObtenerDatos}
          handleClose={toggleModal}
          buttonEnviar={false}
          buttonCancelar={true}
          maxWidth="xl"
        />
      )}

      {abrirDetalle && (
        <SimpleDialogComponent
          open={abrirDetalle}
          modalName={"Procesar - Proceso: " + tituloProceso}
          child={<ContenidosFormProcesosVarios
            ajuste={ajuste} toggleModal={toggleModalProcesar} proceso={procesoSeleccionado} procesar={procesar}
            registrosSeleccionados={selectionModel} owner={owner} />}
          setPushData={procesar}
          handleClose={toggleModalProcesar}
          buttonEnviar={false}
          buttonCancelar={false}
        />
      )}
      {modalStateImpresionEtiquetasComprobantes && (
        <ModalImpresionEtiquetasComprobantes
          open={modalStateImpresionEtiquetasComprobantes}
          modalName={"Etiquetas y Comprobante"}
          mensaje={mensajeImpresionEtiquetasComprobantes}
          handleConfirmImpresionEtiquetas={false}
          handleConfirmImpresionComprobantes={handleConfirmImpresionComprobantes}
          response_procesar={responseProcesar}
          handleClose={toggleModalImpresionEtiquetaComprobante}
        />
      )}
      <Divider />
      <Grid>
        <ListTablePaginated options={options} />
      </Grid>

      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => {
          setSnackbarVisible(false);
        }}
      />

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}>

        <MenuItem onClick={handleHistoricoButton}>
          <HistoryIcon color="info" sx={{ mr: 2 }} />
          Historico
        </MenuItem>
      </Popover>
    </>
  );
};
